import UserActionButtons from '../components/UserActionButtons';
import {
  ToolRendererArgs,
  OnUserInteraction,
  ToolRendererUserSelectedValue,
} from '../types';

const userActionsToolRenderer = (
  toolArgs: ToolRendererArgs,
  onUserInteraction?: OnUserInteraction,
  selectedValue?: ToolRendererUserSelectedValue,
  _isActive?: boolean,
  interactionsDisabled?: boolean,
) => {
  const actions: string[] = Array.isArray(toolArgs?.actions)
    ? toolArgs.actions
    : [];

  return (
    <UserActionButtons
      actions={actions}
      selectedAction={selectedValue?.selectedAction}
      disabled={!!selectedValue || !!interactionsDisabled}
      onSelect={(action) => onUserInteraction?.({ selectedAction: action })}
    />
  );
};

export default userActionsToolRenderer;
